import { hasConditions, serializeConditionTree } from './conditionGroups';

const generatePayload = data => {
  if (!data || !hasConditions(data)) {
    return { payload: [] };
  }

  return {
    payload: serializeConditionTree(data),
  };
};

export default generatePayload;
